import { useEffect, useState, useRef } from 'react';
import axios from 'axios';

import { AuthStatus, useAuth } from '../auth';
import { useLocation, useNavigate } from "react-router-dom";

import { set, useForm } from "react-hook-form";
import { Modal, Popover } from 'bootstrap';


import { ToastContainer, toast } from 'react-toastify';

import Toggle from 'react-toggle'


import NavBar from './navbar';
import Menu   from './menu';

import '../styles/mixts.scss';


const endpoint = process.env.REACT_APP_ENDPOINT;

const Mixts = () => {

    // Datos generales
    const status = AuthStatus();
    const { token } = useAuth();
    const location = useLocation();

    const contractType = location.state?.new;
    const mixtsTypes = [
        { value: "reglamento", label: "Creación de reglamento interior de trabajo." },
        { value: "utilidades", label: "Participación de las y los trabajadores en las utilidades." },
        { value: "declaracion", label: "Exhibición y entrega de declaración anual." },
        { value: "proyecto", label: "Acta de proyecto de reparto de utilidades." },
        { value: "seguridad", label: "Seguridad e higiene en el trabajo." },
        { value: "capacitacion", label: "Capacitacion, productividad y adiestramiento." },
        { value: "antiguedad", label: "Determinar antiguedades."}

    ];

    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
   
    const [collaborators, setCollaborators] = useState([]);
    const [filteredCollaborators, setFilteredCollaborators] = useState([]);
   
    // Campos de form
    const [selectedCollaborators, setSelectedCollaborators] = useState(['', '']);
   
    const [companyAddresses, setCompanyAddresses] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState('');
    const [utilidades, setUtilidades] = useState(false);
    
     const { register, setValue, handleSubmit } = useForm();

    const mixtTitle = mixtsTypes.find(type => type.value === contractType)?.label || "Mixto";
     const navigate = useNavigate();

     const onSubmit = async (data) => {
         if (!selectedCompany) {
             toast.error('Selecciona una empresa antes de guardar.');
             return;
         }

         const payload = {
             tipo: contractType,
             company_id: selectedCompany.id,
             collaborator_id: null,
             data
         };

         try {
             const config = { headers: { Authorization: `Bearer ${token}` } };
             await axios.post(`${endpoint}admin/documents`, payload, config);
             toast.success('Documento creado exitosamente.');
             navigate('/admin/documents');
         } catch (error) {
             toast.error(error.response?.data?.message || 'Error al guardar el documento.');
         }
     };

    // Obtener empresas
    const fetchCompanies = async () => {
        try {
            const response = await axios.get(`${endpoint}admin/companies`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setCompanies(response.data);
            console.log(response.data);
            if (response.data.length > 0) {
                setSelectedCompany(response.data[0]); // Selecciona la primera empresa solo si no hay contrato existente
            }
        } catch (error) {
            toast.error('Error al obtener la lista de compañías');
        }
    };

    // Obtener colaboradores
    const fetchCollaborators = async () => {
        try {
            const response = await axios.get(`${endpoint}admin/collaborators`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setCollaborators(response.data);
        } catch (error) {
            toast.error('Error al obtener la lista de colaboradores');
        }
    };

    // Filtrar colaboradores cuando cambia la empresa seleccionada
    useEffect(() => {
        if (selectedCompany) {
            const filtered = collaborators.filter(col => col.company_id === selectedCompany.id);
            setFilteredCollaborators(filtered);
            
            console.log(selectedCompany)
            setCompanyAddresses(selectedCompany.addresses || []);
            
            //setSelectedAddress("");
            if(selectedCompany.addresses){
                let fiscal = selectedCompany.addresses.filter(a=> a.is_fiscal)
                setSelectedAddress(fiscal[0] || selectedCompany.addresses[0] || null);
            }
            if(selectedCompany && contractType === "seguridad"){
                setValue('giro',selectedCompany.giro_actividad)
                setValue('rfc',selectedCompany.rfc)
                // setValue('prima_vacacional',selectedCompany.benefits.prima_vacacional)
            }
        }
    }, [selectedCompany, collaborators]);


    // Cargar domicilio en form
    useEffect(()=>{
       
        if(selectedAddress && typeof selectedAddress === 'object'){
            setValue('calle', selectedAddress.calle)
            setValue('numero_exterior',selectedAddress.numero_exterior)
            setValue('numero_interior',selectedAddress.numero_interior)
            setValue('ciudad',selectedAddress.ciudad)
            setValue('estado', selectedAddress.estado)
            setValue('colonia', selectedAddress.colonia)
            setValue('codigo_postal', selectedAddress.codigo_postal)
        }
    },[selectedAddress]);


    //Obtener datos 
     useEffect(() => {
        fetchCompanies();
        fetchCollaborators();

        var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
        var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
            return new Popover(popoverTriggerEl, {
                trigger: 'focus' // Se cierra cuando el usuario hace clic fuera
            });
        });
    }, [token]);



    const handleDiscard = ()=>{
        navigate('/admin/documents');
    }

    const handleSelectCollaborator = (newVal,idx)=>{
        setSelectedCollaborators(previous => {
            const next = [...previous];
            next[idx] = Number(newVal);
            return next;
        });
        setValue(idx === 0 ? 'trabajador' : 'trabajador2', Number(newVal));
    }

    const handleUtilidades = (e) => {
        setValue('utilidades', e.target.checked);
        setUtilidades(e.target.checked);
    }



    return(
        <div className="mixts">
            <NavBar auth={status} companies={companies} selected={selectedCompany} set={setSelectedCompany} />
            <div className='mixts-row'>
                <Menu />
                <form className='mixts-wrapper' onSubmit={handleSubmit(onSubmit)}>
                    <ToastContainer />
                    <h2>{ mixtTitle }</h2>
                    <div className='mixts-controls'>
                        <button type='button' className='btn btn-secondary' onClick={handleDiscard}>
                            Descartar
                        </button>
                        <button type='submit' className='btn btn-primary'>
                            Guardar
                        </button>
                    </div>

                    <strong>Datos del Acta</strong>
                    <div className="mixts-general mixts-section">
                        <div className="c-select">
                            <label htmlFor="companie-select">Empresa / Patrón</label>
                            <select
                                required
                                id="companie-select"
                                value={selectedCompany ? selectedCompany.id : ''}
                                onChange={(e) => setSelectedCompany(companies.find(company => company.id === Number(e.target.value)) || null)}
                            >
                                <option value="">Selecciona una opción</option>
                                {companies.map(companie => (
                                    <option key={companie.id} value={companie.id}>
                                        { companie.nombre } 
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="c-input">
                            <label htmlFor="address">Fecha</label>
                            <input type="date" 
                                {...register("fecha", { required: "Especifica fecha de la reunión" })} 
                            />
                        </div>

                        {   (contractType === "declaracion" || contractType === 'proyecto' || contractType === 'seguridad') &&
                            <>
                                <div className="c-input">
                                    <label htmlFor="address">Hora de Inico del Acta</label>
                                    <input type="time" 
                                        {...register("inicio", { required: "Especifica hora de inicio del acta." })}
                                    />
                                </div>
                                <div className="c-input">
                                    <label htmlFor="address">Hora de Cierre del Acta</label>
                                    <input type="time" 
                                        {...register("hora_cierre", { required: "Especifica hora de cierre del acta." })}
                                    />
                                </div>

                            </>

                        }
                        

                    </div>


                    <strong>Lugar de la reunión</strong>
                    <div className="mixts-address mixts-section">
                        
                        <div className="c-input">
                            <label htmlFor="address">Calle</label>
                            <input type="text" 
                                {...register("calle", { required: "Especifica calle" })} 
                            />
                        </div>
                        <div className="c-input">
                            <label htmlFor="address">Número Exterior</label>
                            <input type="text" 
                                {...register("numero_exterior", { required: "Especifica número" })} 
                            />
                        </div>
                        <div className="c-input">
                            <label htmlFor="address">Número Interior</label>
                            <input type="text" 
                                {...register("numero_interior")} 
                            />
                        </div>
                        <div className="c-input">
                            <label htmlFor="address">Código Postal</label>
                            <input type="text" 
                                {...register("codigo_postal", { required: "Especifica CP" })} 
                            />
                        </div>
                        <div className="c-input">
                            <label htmlFor="address">Colonia</label>
                            <input type="text" 
                                {...register("colonia", { required: "Especifica calle" })} 
                            />
                        </div>
                        <div className="c-input">
                            <label htmlFor="address">Ciudad</label>
                            <input type="text" 
                                {...register("ciudad", { required: "Especifica calle" })} 
                            />
                        </div>
                        <div className="c-input">
                            <label htmlFor="address">Estado</label>
                            <input type="text" 
                                {...register("estado", { required: "Especifica calle" })} 
                            />
                        </div>
                    </div>

                    <strong>Representates del Patrón</strong>
                    <div className="mixts-boss mixts-section">
                        <label htmlFor="address">Representante</label>
                        <input type="text" 
                            {...register("rep_patron", { required: "Especifica representante" })} 
                        />
                        <label htmlFor="address">Representante</label>
                        <input type="text" 
                            {...register("rep_patron2", { required: "Especifica representante" })} 
                        />

                    </div>

                    <strong>Representantes Trabajadores</strong>
                    <div className="mixts-workers mixts-section">
                        <div className="c-select">
                            <label htmlFor="collaborator-select">Representate</label>
                            <select
                                required
                                id="companie-select"
                                value={selectedCollaborators[0] ? selectedCollaborators[0] : ''}
                                onChange={(e) => handleSelectCollaborator(e.target.value,0)}
                            >
                                <option value="">Selecciona una opción</option>
                                {filteredCollaborators.map(collaborator => (
                                    <option key={collaborator.id} value={collaborator.id}>
                                        { collaborator.nombre } { collaborator.apellidos } 
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="c-select">
                            <label htmlFor="collaborator-select">Representate</label>
                            <select
                                required
                                id="companie-select"
                                value= {selectedCollaborators[1]}
                                onChange={(e) => handleSelectCollaborator(e.target.value,1)}
                            >
                                <option value="">Selecciona una opción</option>
                                {filteredCollaborators.map(collaborator => (
                                    <option key={collaborator.id} value={collaborator.id}>
                                        { collaborator.nombre } { collaborator.apellidos } 
                                    </option>
                                ))}
                            </select>
                        </div>



                    </div>
                  
                    {
                        (contractType === "declaracion" || contractType === 'proyecto') &&
                        <>
                            <strong>Datos del Ejercicio Fiscal</strong>
                            <div className="mixts-fiscal mixts-section">
                                <div className="c-input">
                                    <label htmlFor="address">Ejercicio Fiscal</label>
                                    <input type="number"
                                        required
                                        max="2099" min="2000" 
                                        {...register("ejercicio", { required: "Especifica fecha de declaración ante el SAT." })}
                                    />
                                </div>

                                {
                                    contractType === "declaracion" &&
                                    <div className="c-input">
                                        <label htmlFor="address">Fecha de Presentación de Declaración Anual al SAT</label>
                                        <input type="date" 
                                            required
                                            {...register("declaracion", { required: "Especifica fecha de declaración ante el SAT." })}
                                        />
                                    </div>

                                }
                                
                            </div>
                        </>
                    }

                    {
                        contractType === "proyecto" &&
                        <>
                            <strong>Respecto a las Utilidades</strong>
                            <div className="mixts-section">
                                <div className="c-input">
                                    <label htmlFor='cheese-status'>¿El Patrón que se trata Genéro Utilidades a Repartir? </label>
                                    <div className="c-toggle">
                                        <Toggle
                                            id='cheese-status'
                                            defaultChecked={false}
                                            onChange={e => handleUtilidades(e)} 
                                        />
                                        { utilidades  ? <span>Si hubo</span> : <span>No hubo</span>}

                                    </div>
                                    
                                </div>

                            </div>
                            
                        </>
                    }

                    {
                        contractType === "seguridad" &&
                        <>
                            <strong>Datos de la Empresa { selectedCompany?.nombre }</strong>
                            <div className="mixts-companie mixts-section">
                                <div className="c-input">
                                    <label htmlFor="inicio">Fecha de Inicio de Actividades</label>
                                    <input type="date" 
                                        id="inicio"
                                        required
                                        {...register("inicio", { required: "Especifica fecha." })}
                                    />
                                </div>
                                <div className="c-input">
                                    <label htmlFor="giro">Giro o Actividad</label>
                                    <input type="text" 
                                        id='giro'
                                        required
                                        {...register("giro", { required: "Especifica giro." })}
                                    />
                                </div>

                                <div className="c-input">
                                    <label htmlFor="rfc">RFC</label>
                                    <input type="text" 
                                        id="rfc"
                                        required
                                        
                                        {...register("rfc", { required: "Especifica rfc." })}
                                    />
                                </div>

                                <div className="c-input">
                                    <label htmlFor="registro_patronal">Registro Patronal</label>
                                    <input type="text" 
                                        required
                                        minLength={11}
                                        maxLength={11}
                                        id="registro_patronal"
                                        {...register("registro_patronal", { required: "Especifica registro." })}
                                    />
                                </div>

                                <div className="c-input">
                                    <label htmlFor="telefono">Teléfono de Contacto</label>
                                    <input type="tel" 
                                        required
                                     
                                        id="telefono"
                                        {...register("telefono", { required: "Especifica teléfono." })}
                                    />
                                </div>

                                <div className="c-input">
                                    <label htmlFor="email">Correo Electrónico de Contacto</label>
                                    <input type="email" 
                                        required
                                       
                                        id="email"
                                        {...register("email", { required: "Especifica correo." })}
                                    />
                                </div>


                            </div>

                            <strong>Datos del Centro de Trabajo</strong>
                            <div className="mixts-companie mixts-section">
                                <div className="c-input">
                                    <label htmlFor="empleados">Número de Empleados en el Centro de Trabajo</label>
                                    <input type="number" 
                                        required
                                        
                                        id="empleados"
                                        {...register("empleados", { required: "Especifica número." })}
                                    />
                                </div>
                                <div className="c-input">
                                    <label htmlFor="turnos">Turnos</label>
                                    <input type="number" 
                                        required
                                        min={1}
                                        max={10}
                                        id="turnos"
                                        {...register("turnos", { required: "Especifica número." })}
                                    />
                                </div>

                            </div>
                        </>
                    }
                   

                    <button id='submit' className='btn btn-primary'>
                        Crear documento
                    </button>
                </form>
            </div>
        </div>
    );

};

export default Mixts;
